import {createHttpClient, getStoredSession} from "./client";

function normalizeLoginChallenge(payload) {
  if (!payload || typeof payload !== "object") return payload;
  return {
    ...payload,
    loginToken: payload.loginToken || payload.wxLoginToken || ""
  };
}

/**
 * 账号认证接口封装：支持邮箱验证码和公众号消息验证码。
 */
export function createAuthApi(baseUrl) {
  const http = createHttpClient(baseUrl);

  return {
    /**
     * 线上后端当前没有 bootstrap 接口，这里返回本地引导文案，避免初始化误报 404。
     */
    fetchBootstrap() {
      return Promise.resolve({
        browserContext: "未登录",
        recommendedFlow: "可使用邮箱验证码或公众号快捷登录。"
      });
    },

    sendEmailLoginCode(email) {
      return http.post("/quark/auth/email/send-code", { email });
    },

    loginWithEmail(email, code) {
      return http.post("/quark/auth/email/login", { email, code });
    },

    bindEmail(email, code) {
      return http.post("/quark/auth/email/bind", {
        email,
        code,
        wxLoginToken: getStoredSession()
      });
    },

    /**
     * 创建一条消息登录挑战，返回验证码、token 和二维码信息。
     */
    async createMessageLoginChallenge(redirectUri, bindToken) {
      const payload = await http.get("/quark/auth/wechat/message-login/challenge", {
        params: { redirectUri, bindToken }
      });
      return normalizeLoginChallenge(payload);
    },

    /**
     * 查询某次登录挑战状态。
     */
    fetchMessageLoginStatus(loginToken) {
      return http.get("/quark/auth/wechat/message-login/status", {
        params: { wxLoginToken: loginToken }
      });
    },

    /**
     * 获取公众号关注指引信息。
     */
    fetchFollowGuide() {
      return http.get("/quark/auth/wechat/follow-guide");
    },

    /**
     * 获取当前登录用户信息。
     */
    fetchCurrentUser() {
      const wxLoginToken = getStoredSession();
      return http.get("/quark/auth/wechat/me", {
        params: wxLoginToken ? { wxLoginToken } : undefined
      })
    },

    /**
     * 获取个人中心资料。
     */
    fetchProfile(wxLoginToken) {
      return http.get("/quark/bead/user/queryUserInfo", {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },

    /**
     * 保存个人中心资料。
     */
    updateProfile(payload) {
      return http.post("/quark/bead/user/updateUserInfo", payload);
    },

    /**
     * 上传头像图片。
     */
    uploadAvatar(file) {
      const formData = new FormData();
      formData.append("file", file);
      return http.post("/infra/file/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    },

    /**
     * 退出登录。
     */
    logout(loginToken) {
      const wxLoginToken = loginToken || getStoredSession();
      return http.get("/quark/auth/wechat/logout", {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    }
  };
}
